import {KeyForArticleSearchType} from './search-type';

export const articlePreviewKeyList: KeyForArticleSearchType = ['slug', 'title'];
